import { IResultMessage } from "./responses";

/**
 * Výsledek operace spuštení aplikační metody
 */
export interface IRunMethodResult extends ILongTransactionResult {
    /** Výsledek vrácený metodou, nepovinný. */
    readonly resultValue: any | undefined;
    /** Zprávy: informace, varování, chyby, které mohly vzniknout během běhu metody. */
    readonly messages: IResultMessage[];
}

export interface ILongTransactionResult {
    /** True - metoda se neukončila během uvedeného času a běží v režimu dlouhé transakce */
    isInLongTransaction: boolean;
}
